<template>
  <a-modal
    title="创建优惠券"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="券名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入券名称" v-decorator="['name', {rules: [{required: true, message: '请输入券名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="券金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input-number  style="width: 95%"  placeholder="请输入券金额" v-decorator="['amount', {rules: [{required: true, message: '请输入券金额！'}]}]"  />
        元
        </a-form-item>
        <a-form-item
          label="有效期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择有效期" v-decorator="['validDate',{rules: [{ required: true, message: '请选择有效期！' }]}]" @change="onChangevalidDate"/>
        </a-form-item>
        <a-form-item
          label="券数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input-number  style="width: 95%"  placeholder="请输入券数量,不得大于100张" v-decorator="['num', {rules: [{required: true, message: '请输入券数量！'}]}]"   /> 张
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { buCouponAdd } from '@/api/modular/interhospital/bucoupon/buCouponManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        validDateDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        this.visible = true
      },
      /**
       * 提交表单
       */
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            if(Number(values.amount) >5){
              this.$message.warning('券金额不得大于5元')
              this.confirmLoading = false
              return
            }else if(Number(values.amount) <=0){
              this.$message.warning('券金额必须大于0元')
              this.confirmLoading = false
              return
            }
            if(Number(values.num) >100){
              this.$message.warning('券数量不得大于100张')
              this.confirmLoading = false
              return
            }else if(Number(values.num)<1){
              this.$message.warning('券数量最少为1张')
              this.confirmLoading = false
              return
            }
            
            
            values.validDate = this.validDateDateString
            buCouponAdd(values).then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('新增失败')// + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangevalidDate(date, dateString) {
        this.validDateDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
<style scoped>

 /deep/.ant-form-item-children-icon{
  display: none !important;
}
</style>
